import script from "./AssignAstigmatism.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignAstigmatism.vue?vue&type=script&setup=true&lang=js"

import "./AssignAstigmatism.vue?vue&type=style&index=0&id=2295a897&scoped=true&lang=css"
import "./AssignAstigmatism.vue?vue&type=style&index=1&id=2295a897&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2295a897"]])

export default __exports__